import React from 'react';
import { RatingCard } from './RatingCard';
export function FeaturedRatings() {
  const games = [{
    title: 'Veilstorm Chronicles',
    genre: 'RPG',
    score: 94,
    criticScore: 96,
    userScore: 91,
    price: 59.99,
    image: 'https://images.unsplash.com/photo-1542751371-adc38448a05e?ixlib=rb-4.0.3&auto=format&fit=crop&w=800&q=80'
  }, {
    title: 'Ashborne Requiem',
    genre: 'Action',
    score: 88,
    criticScore: 85,
    userScore: 90,
    price: 49.99,
    image: 'https://images.unsplash.com/photo-1552820728-8b83bb6b773f?ixlib=rb-4.0.3&auto=format&fit=crop&w=800&q=80'
  }, {
    title: 'Noctis Wanderer',
    genre: 'Open World',
    score: 91,
    criticScore: 93,
    userScore: 88,
    price: 54.99,
    image: 'https://images.unsplash.com/photo-1511512578047-dfb367046420?ixlib=rb-4.0.3&auto=format&fit=crop&w=800&q=80'
  }, {
    title: 'Ecliptic Frontier',
    genre: 'Sci-Fi Strategy',
    score: 82,
    criticScore: 80,
    userScore: 84,
    price: 39.99,
    image: 'https://images.unsplash.com/photo-1614720332169-d6c33003a8bf?ixlib=rb-4.0.3&auto=format&fit=crop&w=800&q=80'
  }, {
    title: 'Thornhaven Siege',
    genre: 'Tower Defense',
    score: 76,
    criticScore: 74,
    userScore: 79,
    price: 29.99,
    image: 'https://images.unsplash.com/photo-1533236897111-3e94666b2edf?ixlib=rb-4.0.3&auto=format&fit=crop&w=800&q=80'
  }, {
    title: "Luminara's Descent",
    genre: 'Metroidvania',
    score: 87,
    criticScore: 89,
    userScore: 85,
    price: 34.99,
    image: 'https://images.unsplash.com/photo-1509198397868-475647b2a1e5?ixlib=rb-4.0.3&auto=format&fit=crop&w=800&q=80'
  }];
  return <section className="py-24 bg-pinnacle-dark" data-id="element-19">
      <div className="container mx-auto px-4" data-id="element-20">
        <div className="flex items-end justify-between mb-12" data-id="element-21">
          <div data-id="element-22">
            <h2 className="text-3xl md:text-4xl font-bold text-white mb-2" data-id="element-23">
              Trending Now
            </h2>
            <p className="text-gray-400" data-id="element-24">
              The hottest releases ranked by the Pinnacle Score.
            </p>
          </div>
          <button className="hidden md:block text-pinnacle-green hover:text-white transition-colors font-medium" data-id="element-25">
            View All Games →
          </button>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6" data-id="element-26">
          {games.map((game, idx) => <RatingCard key={idx} {...game} delay={idx * 100} data-id="element-27" />)}
        </div>

        <div className="mt-8 text-center md:hidden" data-id="element-28">
          <button className="text-pinnacle-green hover:text-white transition-colors font-medium" data-id="element-29">
            View All Games →
          </button>
        </div>
      </div>
    </section>;
}